<template>
  <div>
    <div class="home d-flex">
      <div class="intro-text d-flex align-items-end px-md-5">
        <div>
          <h1>{{ $t('Bory Prvé Domy') }}</h1>
          <p>{{ $t('Prvú etapu projektu tvorí deväť bytových') }}
          </p>
          <b-button to="/nasa-stvrt" class="d-block d-md-inline-block" squared variant="primary">{{ $t('O bývaní na Boroch') }}</b-button>
        </div>
      </div>
    </div>

    <section class="district p-md-3 pt-3 pt-md-5">
      <div class="d-flex flex-wrap align-items-start top mb-5">
        <div class="col-md-6 px-md-5">
          <h2 class="mb-4 m-md-0">{{ $t('Mesto tak, ako ho poznáte') }}</h2>
        </div>
        <div class="col-md-6 d-flex justify-content-center">
          <p class="m-0">{{ $t('Bory kombinujú aktívne rodinné bývanie') }}</p>
        </div>
      </div>
    </section>



    <section class="section-3 p-3">
      <div class="">
        <div class="row px-3 mb-3">
          <div class="col-md-7 bg-img"></div>
          <div class="col-md-5 p-0 px-md-5 py-3">
            <h2 v-html="$t('Buďte pri tom,<br> čo potrebujete')"></h2>
            <p>{{ $t('Bory Bývanie je pilotný projekt novej') }}</p>
          </div>
        </div>
        <div class="row px-2">
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-1">
              <h3 v-html="$t('17 400 m<sup>2</sup><br> zelene')"></h3>
              <p>{{ $t('Priestranný park plný zelene, detské ihrisko, workout zóna a altánok. Vybavenie dôležité pre oddych, ale aj aktívne trávenie voľného času.') }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-2">
              <h3 v-html="$t('196 pešo dostupných<br> obchodov')"></h3>
              <p>{{ $t('Obchodný dom Bory Mall je v pešej dostupnosti, navyše s bohatou ponukou obchodov, služieb a reštaurácií.') }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-3">
              <h3 v-html="$t('466 parkovacích miest<br> pre obyvateľov')"></h3>
              <p>{{ $t('Projekt prináša obyvateľom dostatočný počet parkovacích miest, ktoré navyše nenarúšajú kvalitný verejný priestor.') }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <ScheduleTimeline :phases="schedulePhases" />

    <section class="about-bottom p-md-3 pl-md-5">
      <div class="d-flex flex-wrap">
        <div class="col-md-6 py-5">
          <h2 class="mb-4">{{ $t('Domov, ktorý je pohodlný') }}</h2>
          <p class="mb-5">{{ $t('Byty v novej štvrti majú praktické dispozície') }}</p>
<!--          <b-button squared variant="primary" class="download-btn download-btn-white">Stiahnuť katalóg štandardov</b-button>-->
        </div>
        <div class="col-md-6 pb-3 pb-md-0 pr-md-0">
          <div class="right-img"></div>
        </div>
      </div>
    </section>

    <section class="about-bottom-2">
      <div class="d-flex flex-wrap">
        <div class="col-md-6 bg"></div>
        <div class="col-md-6 signature-section">
          <h2 class="mb-4" v-html="$t('Kompletná<br> občianska vybavenosť')"></h2>
          <p class="">{{ $t('Priamo v novej štvrti majú obyvatelia') }}</p>
        </div>
      </div>
    </section>

    <ContactForm></ContactForm>
  </div>
</template>

<script>
import ContactForm from "@/components/shared/ContactForm";
import ScheduleTimeline from "@/components/home/ScheduleTimeline";
export default {
  name: "Bory1",
  components: {ContactForm, ScheduleTimeline},
  data() {
    return {
      schedulePhases: [
        { icon: 'zahajenie-vystavby', title: 'Zahájenie<br> výstavby', date: '1. kvartál 2017', status: 'fill' },
        { icon: 'hruba-stavba', title: 'Dokončenie<br> hrubej stavby', date: '4. kvartál 2017', status: 'fill' },
        { icon: 'kolaudacia', title: 'Plánovaná<br> kolaudácia', date: '4. kvartál 2018', status: 'fill' },
        { icon: 'odovzdanie-bytov', title: 'Odovzdanie<br> bytov', date: '2. kvartál 2019', status: 'fill' },
        { icon: 'kluce-byvanie', title: 'Vaše<br> bývanie', status: 'fill' }
      ]
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="sass" scoped>
$md: 768px
.about-bottom-2
  .bg
    background: url(../assets/images/bory1/bottom-image.jpg) center/cover no-repeat
.about-bottom
  .right-img
    background: url(../assets/images/bory1/bory1-standard.jpg) center/cover no-repeat

.section-3
  background: var(--grey)
  color: #fff
  text-align: left
  .bg-img
    background: url("../assets/images/bory1/budte-pri-tom.jpg") center/cover no-repeat
    @media (max-width: $md)
      height: 40vh
      background-size: cover
  h2
    font-size: 55px
    line-height: 60px
    font-weight: 300
    margin-bottom: 20px
    @media (max-width: $md)
      font-size: 28px
      line-height: 40px
      letter-spacing: -1px
      margin-bottom: 15px
  p
    max-width: 320px
    font-weight: 500
    &:last-child
      margin-bottom: 220px
      @media (max-width: $md)
        margin-bottom: 0
  .bg-col
    height: 800px
    @media (max-width: $md)
      height: 60vh
      margin-bottom: 16px
      padding: 30px
    h3
      font-size: 28px
      line-height: 32px
      font-weight: 400
      margin-bottom: 20px
    p
      font-size: 16px
      line-height: 21px
      font-weight: 500
      @media (max-width: $md)
        font-size: 12px
        line-height: 16px
        max-width: 100%
  .bg-col-1
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory1/bory1-zelen.jpg") center/cover no-repeat
  .bg-col-2
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory1/bory1-vybavenost.jpg") bottom/cover no-repeat
  .bg-col-3
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory1/bory1-parkovanie.jpg") center/cover no-repeat
  .col-md-4
    padding-left: 8px
    padding-right: 8px
.home
  background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory1/bory1.jpg") bottom/cover no-repeat
  p
    margin-bottom: 30px
    max-width: 770px

.district
  background: var(--darkBlue)
  img
    width: 100%
.top
  h2
    font-weight: 300
    font-size: 55px
    line-height: 60px
    letter-spacing: -3px
    @media (max-width: $md)
      font-size: 40px
      line-height: 40px
      letter-spacing: -2px
  p
    font-weight: 500
    max-width: 415px
</style>